import { IHttpApi } from '@cian/http-api';
import {
  fetchCloudpaymentsStartWidgetPayment,
  IMappers,
} from '../../../repositories/billing-accounts/v1/cloudpayments/start-widget-payment';
import { EPaymentInitSource } from '../../../types/redux/checkout';
import { THeaders } from '../../../types/request';
import { IGetBaseCloudPaymentsWidgetParamsResult } from './types';
import { mapResponse200 } from './utils';
import { DEFAULT_RESULT } from './constants';

interface IParams {
  httpApi: IHttpApi;
  amount: number;
  paymentInitSource: EPaymentInitSource;
  transactionId: string | undefined;
}

export const getBaseCloudPaymentsWidgetParams = async (
  params: IParams,
): Promise<IGetBaseCloudPaymentsWidgetParamsResult> => {
  const { httpApi, amount, paymentInitSource } = params;

  const parameters = {
    paymentInitSource,
    amount,
  };

  const mappers: IMappers<IGetBaseCloudPaymentsWidgetParamsResult> = {
    200: mapResponse200({ amount }),
  };

  const headers: THeaders = [['Content-Type', 'application/json']];

  const config = {
    requestConfig: {
      headers,
    },
  };

  try {
    const result = await fetchCloudpaymentsStartWidgetPayment({ httpApi, parameters, mappers, config });

    return result as IGetBaseCloudPaymentsWidgetParamsResult;
  } catch {
    return DEFAULT_RESULT;
  }
};
